import React, {useEffect, useRef, useState} from "react";
import tools from "../../assets/images/tools.png";
import ok_daxosoxong from "../../assets/images/ok_daxosoxong.png";
import tructiepxoso from "../../assets/images/tructiepxoso.gif";
import choxoso from "../../assets/images/choxoso.gif";
import LotteryResultToday from "./LotteryResultToday";
import News from "./News";
import LeftAds from "./ads/LeftAds";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import styled from "styled-components";
import "react-calendar/dist/Calendar.css";
import LBanner from "../../assets/images/banner/l-banner.gif";

const LeftSide = ({...props}) => {
    const {onChangeDate} = props;
    const [value, onChange] = useState(new Date());

    const bottomAdsStartRef = useRef(null);
    const bottomAdsStartOffsetRef = useRef(0);
    const animationFrameRef = useRef(null);
    const [bottomAdsPaddingTop, setBottomAdsPaddingTop] = useState(0);

    useEffect(() => {
        const updateBottomAdsPosition = () => {
            const nextPaddingTop = Math.max(
                0,
                window.pageYOffset - bottomAdsStartOffsetRef.current
            );

            setBottomAdsPaddingTop(nextPaddingTop);
            animationFrameRef.current = null;
        };

        const measureBottomAdsStart = () => {
            const bottomAdsStart = bottomAdsStartRef.current;

            if (!bottomAdsStart) {
                return;
            }

            bottomAdsStartOffsetRef.current =
                window.pageYOffset + bottomAdsStart.getBoundingClientRect().top;
            updateBottomAdsPosition();
        };

        const handleScroll = () => {
            if (animationFrameRef.current) {
                return;
            }

            animationFrameRef.current = window.requestAnimationFrame(
                updateBottomAdsPosition
            );
        };

        measureBottomAdsStart();

        window.addEventListener("scroll", handleScroll, {passive: true});
        window.addEventListener("resize", measureBottomAdsStart);
        window.addEventListener("load", measureBottomAdsStart);

        return () => {
            if (animationFrameRef.current) {
                window.cancelAnimationFrame(animationFrameRef.current);
            }

            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", measureBottomAdsStart);
            window.removeEventListener("load", measureBottomAdsStart);
        };
    }, []);

    return (
        <td id="left-side" className="left">
            <div id="dnw-left">
                <div>
                    <div>
                        <div className="modulesLR moduleBrown">
                            <div className="title-l">
                                <div className="title-r">
                                    <h1>
                                        <a href="/">Tường Thuật Trực Tiếp Xổ Số</a>
                                    </h1>
                                </div>
                            </div>
                            <div className="body-l">
                                <div className="body-r">
                                    <ul className="menu menuxosott">
                                        <li>
                                            <a href="/" title="Trực Tiếp Xổ Số Miền Nam">
                        <span id="mnxstt_mien-nam" className="icon wait">
                          Trực Tiếp Xổ Số Miền Nam
                        </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/" title="Trực Tiếp Xổ Số Miền Bắc">
                        <span id="mnxstt_mien-bac" className="icon wait">
                          Trực Tiếp Xổ Số Miền Bắc
                        </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/" title="Trực Tiếp Xổ Số Miền Trung">
                        <span id="mnxstt_mien-trung" className="icon wait">
                          Trực Tiếp Xổ Số Miền Trung
                        </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/" title="Trực Tiếp Xổ Số Vietlott">
                        <span
                            id="mnxstt_dien-toan-vietlott"
                            className="icon wait"
                        >
                          Trực Tiếp Xổ Số Vietlott
                        </span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul className="menu">
                                        <li>
                                            <div>
                                                <img alt="" height="10" src={choxoso} width="30"/>
                                                &nbsp;chờ,{" "}
                                                <img alt="" height="8" src={tructiepxoso} width="35"/>
                                                &nbsp;đang xổ,{" "}
                                                <img
                                                    alt=""
                                                    height="10"
                                                    src={ok_daxosoxong}
                                                    width="10"
                                                />
                                                mới
                                            </div>
                                            <ul>
                                                <li style={{textAlign: "right"}}>
                                                    <a href="/">Lịch Mở Thưởng</a>
                                                </li>
                                                <li style={{textAlign: "right"}}>
                                                    <a href="/">
                                                        <img alt="" src={tools} border="0"/> Ch&egrave;n
                                                        Kqxs v&agrave;o Websites
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="clear"/>
                    </div>
                    <div>
                        <div>
                            <strong>
                                <a className="dvs_linkdoisotrung" href="/">
                                    ĐỔI SỐ TRÚNG .COM
                                </a>
                            </strong>
                        </div>
                        <div className="clear"/>
                    </div>
                    {/*<Calendar1 />*/}
                    <CalendarContainer>
                        <Calendar
                            className="border-bottom-0"
                            maxDate={new Date()}
                            onChange={onChange}
                            value={value}
                            onClickDay={(date) => onChangeDate(date)}
                        />
                        <div className="hom-nay">Hôm nay</div>
                    </CalendarContainer>
                    <div>
                        <table
                            style={{
                                width: "100%",
                                border: "0",
                                cellSpacing: "0",
                                cellPadding: "0",
                            }}
                        >
                            <tbody>
                            <tr>
                                <td style={{align: "center", valign: "top"}}>
                                    <form
                                        style={{padding: "0", margin: "0 0 5px 0"}}
                                        name="findDayright"
                                        action="#"
                                    >
                                        <input type="hidden" name="day" id="day"/>
                                        <div id="cont"/>
                                    </form>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <LotteryResultToday/>
                    <div ref={bottomAdsStartRef}/>
                    <div
                        style={{
                            paddingTop: bottomAdsPaddingTop,
                            transition: "padding-top 500ms ease-out"
                        }}>
                        <News/>
                        <div
                            id="parent_left"
                            style={{position: "relative", overflow: "hidden"}}
                        >
                            <div id="sidebarleft" style={{position: "relative", top: "0px"}}>
                                {/*@include('contents.sides.ads.left-ads')*/}
                                <LeftAds image={LBanner} id="left-ads"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </td>
    );
};

export default LeftSide;

const CalendarContainer = styled.div`
    border-radius: 5px;

    .react-calendar__month-view__days {
        margin: 0 1px 1px;
        border: 1px solid #f7f7f7;
        cursor: pointer;
        line-height: 1.2;
        text-align: right;
        color: #222;
    }

    .react-calendar__navigation {
        display: flex;

        .react-calendar__navigation__label {
            font-weight: bold;
            font-size: 12px;
        }

        .react-calendar__navigation__arrow {
            flex-grow: 0.333;
            font-size: 20px;
        }
    }
`;
